import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { postForgotPassword } from '../../actions/auth';
import validator from 'validator';
import { Button, CssBaseline, TextField, Container, Paper } from '@mui/material';
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import backgroundImage from "../../img/LEVLR-Login-Background.jpg";
import levlr_logo from "../../img/LEVLR Logo_CMYK.png";

const ForgotPasswordInner = () => {
  const [credentials, setCredentials] = useState({});
  const [validEmail, setValidEmail] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { executeRecaptcha } = useGoogleReCaptcha();

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedValue = name === "email" ? value.toLowerCase().trim() : value.trim();
    setValidEmail(name === "email" ? validator.isEmail(updatedValue) : validEmail);
    setCredentials(prev => ({ ...prev, [name]: updatedValue }));
  };

  // Submit forgot password request with reCAPTCHA
  const sendEmail = async (e) => {
    e.preventDefault();
    setErrorMessage('');

    if (!executeRecaptcha) {
      setErrorMessage("reCAPTCHA not ready. Try again later.");
      return;
    }

    try {
      const recaptchaToken = await executeRecaptcha('forgotPassword');
      await dispatch(postForgotPassword({ credentials, recaptchaToken }));
      navigate('/login'); // redirect after success
    } catch (err) {
      setErrorMessage(err.message || "Failed to send password reset email.");
    }
  };

  // Styles
  const styles = {
    backGround: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundImage: `url(${backgroundImage})`,
      backgroundSize: 'cover',
      width: '100%',
      height: '100vh',
      padding: '10% 0'
    },
    paper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      backgroundColor: 'rgba(255,255,255,0.5)',
      width: '70%',
      padding: '4vh 0',
      margin: '0 auto'
    },
    textField: { width: '65%', marginBottom: '1rem' },
    button: { width: '50%', color: '#fff', backgroundColor: '#2fb7b7', margin: 16, '&:hover': { backgroundColor: '#01656a' } },
    logo: { width: '40%', height: 'auto', marginBottom: '1rem' }
  };

  return (
    <div style={styles.backGround}>
      <Container component="main">
        <CssBaseline />
        <Paper style={styles.paper}>
          <img src={levlr_logo} alt="Levlr Logo" style={styles.logo} />
          <form style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }} noValidate onSubmit={sendEmail}>
            <h1>Forgot Password?</h1>
            <div>Please Enter Your Email</div>
            <div>Please Note: Emails and Passwords are Case Sensitive</div>

            <TextField
              id="email"
              label="Email"
              name="email"
              onChange={handleChange}
              placeholder="Email Address"
              style={styles.textField}
              error={!validEmail}
              helperText={validEmail ? "" : "Please enter a valid email"}
            />

            <Button
              type="submit"
              style={styles.button}
              disabled={!validEmail}
            >
              Send Password Reset Email
            </Button>

            {errorMessage && <div style={{ color: 'red', marginTop: '10px' }}>{errorMessage}</div>}
          </form>

          <Button style={styles.button} onClick={() => navigate('/login')}>
            Return to Login
          </Button>
        </Paper>
      </Container>
    </div>
  );
};

// Wrap the component with reCAPTCHA provider
const ForgotPassword = () => (
  <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}>
    <ForgotPasswordInner />
  </GoogleReCaptchaProvider>
);

export default ForgotPassword;
